import type { ExecutionImageView } from '@/lib/api/generated/model';
import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

/**
 * Confirms removing one catalog entry — blocked while it is the workspace's
 * default (FR-011, SC-004): the backend rejects this too
 * (`EXECUTION_IMAGE_CANNOT_DELETE_DEFAULT`), but blocking it here first means
 * the confirm button is never clickable on a doomed request.
 */
export function DeleteExecutionImageDialog({
  image,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  image: ExecutionImageView;
  open: boolean;
  isPending: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const blocked = image.is_default;

  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{image.label}&rdquo;?</>}
      confirmLabel="Delete image"
      isPending={isPending}
      error={error}
      confirmDisabled={blocked}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {blocked
        ? `"${image.label}" is the workspace's default image and cannot be deleted. Make another image the default first.`
        : `This removes "${image.label}" from the catalog. It cannot be undone.`}
    </ConfirmDestructiveDialog>
  );
}
